import { getContactPerson } from '@debbie/common/dist/customers/index.js';
import { Site } from '@debbie/common/dist/index.js';
import { Direction, } from '@debbie/common/dist/interactions/index.js';
import { useCase } from '@debbie/cortex/dist/cases/index.js';
import { useCustomer } from '@debbie/cortex/dist/customers/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import DefaultSummary from './DefaultSummary.js';
const DebtorMessageSummary = (props) => {
    const site = useSelector((s) => s.site);
    // The recipient is the case's contact person on the customer, which is
    // resolved through customer data only caseworkers can read — other sites get
    // the plain summary. Incoming messages are from the debtor, so there is no
    // recipient to show (the sender is shown as "performed by" in the heading).
    if (site !== Site.Caseworker ||
        props.interaction.direction !== Direction.OUTGOING) {
        return React.createElement(DefaultSummary, { ...props, notesOutsideBox: true });
    }
    return React.createElement(DebtorMessageSummaryWithRecipient, { ...props });
};
const DebtorMessageSummaryWithRecipient = (props) => {
    const lang = useSelector((s) => s.lang);
    const caseLoadable = useCase(props.longCaseId);
    const singleCase = h.hasData(caseLoadable) ? caseLoadable.data : null;
    const customerLoadable = useCustomer(singleCase?.customerId);
    const customer = h.hasData(customerLoadable) ? customerLoadable.data : null;
    const contact = customer && singleCase ? getContactPerson(customer, singleCase) : null;
    const metaData = contact
        ? [
            {
                header: lang.interactions.to,
                body: (React.createElement("b", null, contact.details.email != null && contact.details.email !== ''
                    ? `${contact.details.name} (${contact.details.email})`
                    : contact.details.name)),
            },
        ]
        : [];
    // With a recipient row the message belongs inside the box below it (same
    // layout as emails); without one the message renders plain like a note.
    return (React.createElement(DefaultSummary, { ...props, metaData: metaData, notesOutsideBox: metaData.length === 0 }));
};
export default DebtorMessageSummary;
//# sourceMappingURL=DebtorMessageSummary.js.map